module.exports = __webpack_public_path__ + "img/approved_home.3f46a190.png";